import React from 'react'

function Loading() {
   
  return (
   <div className="loading-container">
        <img className='loading-gif' src="https://vafloc01.s3.amazonaws.com/WBStatic/site1102601/dist/img/loader.gif" alt="gif" />
        </div>
  )
  
}

export default Loading